import React from "react";
import styled from "@emotion/styled";
import { Header } from "../../components/typography/Header";
import {
  FONT_SIZE_HEADER_MOBILE,
  FONT_SIZE_LARGE,
  MOBILE_SCREEN,
  IconSize,
  GROUP_ICON_COLORS,
} from "../../components/theme";
import useIsMobile from "../../hooks/useIsMobile";
import { ICON_COMPONENTS, getIconBackgroundColor } from "./utils/icons";
import Checkbox from "../../components/icons/Checkbox";
import IconContainer from "../../components/icons/IconContainer";

const StyledGroupTitleContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  margin-bottom: 16px;
  ${MOBILE_SCREEN} {
    gap: 8px;
  }
`;

const StyledGroupHeader = styled(Header)`
  font-size: ${FONT_SIZE_HEADER_MOBILE};
  ${MOBILE_SCREEN} {
    font-size: ${FONT_SIZE_LARGE};
  }
`;

export const StyledGroupIconContainer = styled(IconContainer)`
  flex-shrink: 0;
`;

interface GroupTitleProps {
  title: string;
  groupIcon?: string | null;
}

const GroupTitle: React.FC<GroupTitleProps> = ({ title, groupIcon }) => {
  const isMobile = useIsMobile();
  const backgroundColor = groupIcon
    ? getIconBackgroundColor(groupIcon)
    : GROUP_ICON_COLORS.LIGHT_PINK;

  // Get the appropriate icon component if groupIcon exists
  const IconComponent = groupIcon
    ? ICON_COMPONENTS[groupIcon as keyof typeof ICON_COMPONENTS]
    : null;

  return (
    <StyledGroupTitleContainer>
      {groupIcon && IconComponent && (
        <StyledGroupIconContainer backgroundColor={backgroundColor}>
          {groupIcon === "CHECKBOX" ? (
            <Checkbox
              isChecked={true}
              size={isMobile ? IconSize.L : IconSize.XL}
            />
          ) : (
            <IconComponent
              size={isMobile ? IconSize.L : IconSize.XL}
              isChecked={false}
            />
          )}
        </StyledGroupIconContainer>
      )}
      <StyledGroupHeader>{title}</StyledGroupHeader>
    </StyledGroupTitleContainer>
  );
};

export default GroupTitle;
